require("capability/es5");
module.exports = require("./lib");